import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=63af0039&"
import script from "./BaseForm.vue?vue&type=script&lang=js&"
export * from "./BaseForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports